import React from 'react';
import { DropZone } from './DropZone';
import { ImageGrid } from './ImageGrid';
import { useImageUpload } from './useImageUpload';
import type { ImageUploadProps } from './types';

export const ImageUpload: React.FC<ImageUploadProps> = ({ onImagesSelected }) => {
  const { images, onDrop, removeImage, updateKeywords } = useImageUpload(onImagesSelected);

  return (
    <div className="space-y-4">
      <DropZone onDrop={onDrop} />
      
      <ImageGrid
        images={images}
        onRemoveImage={removeImage}
        onUpdateKeywords={updateKeywords}
      />
      
      {images.length > 0 && (
        <div className="text-sm text-sage-600">
          {images.length} of 50 images selected
        </div>
      )}
    </div>
  );
};